import { createSlice } from "@reduxjs/toolkit";
import apiManagerSystem from "api/manager-systems";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerSystem.getConfig(data);

        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.total
            }))
        }

        else console.log("info: ", res);
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    searchQuery: {
        code: "",
        value: "",
        description: ""
    }
}

export const managerSystemSlice = createSlice({
    name: 'managersystem',
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload)
    }
})

export const { setTableData, setSearchQuery } = managerSystemSlice.actions
export default managerSystemSlice.reducer